import { PROPERTY_IMAGE_ANALYSIS_API } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetPropertyImageAnalysisError,
  GetPropertyImageAnalysisVariables,
  fetchGetPropertyImageAnalysis,
} from '../toolkitComponents.ts';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = PROPERTY_IMAGE_ANALYSIS_API.GET;

export const useGetPropertyImageAnalysis = (
  variables: GetPropertyImageAnalysisVariables,
  opts?: Omit<
    UseQueryOptions<z.infer<typeof API_SCHEMA.RESPONSE>, GetPropertyImageAnalysisError>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<z.infer<typeof API_SCHEMA.RESPONSE>, GetPropertyImageAnalysisError> => {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<z.infer<typeof API_SCHEMA.RESPONSE>, GetPropertyImageAnalysisError>({
    queryKey: queryKeyFn({
      path: '/api/v2/orders/{orderID}/property/{propertyID}/imageAnalysis',
      operationId: 'getPropertyImageAnalysis',
      variables,
    }),
    queryFn: async () => {
      const res = await fetchGetPropertyImageAnalysis({ ...fetcherOptions, ...variables });
      return API_SCHEMA.RESPONSE.parse(res);
    },
    ...opts,
  });
};
